@let alignIconToRightValue = alignIconToRight();

<div
  class="custom-icon-button"
  [class]="'custom-icon-button--' + colorScheme()"
  [class.disabled]="disabled()"
  [class.button--critical]="isCritical()"
>
  <kds-large-button
    [testId]="testId()"
    [colorScheme]="colorScheme()"
    [isCritical]="isCritical()"
    [disabled]="disabled()"
    [buttonText]="buttonText()"
    [loading]="loading()"
    [type]="type()"
    [alignContentToRight]="alignIconToRightValue"
    (buttonClick)="buttonClick.emit($event)"
  >
    <div class="custom-icon-button__content">
      @if (iconClass(); as iconClassValue) {
        <i
          class="custom-icon-button__icon"
          [class.custom-icon-button__icon--aligned-to-right]="alignIconToRightValue"
          [class]="iconClassValue"
        ></i>
      }
      <ng-content />
    </div>
  </kds-large-button>
</div>
